import { Package } from "lucide-react";

interface DescriptionSectionProps {
  formData: any;
  setFormData: (data: any) => void;
}

const DescriptionSection: React.FC<DescriptionSectionProps> = ({
  formData,
  setFormData
}) => {
  return (
    <div className="bg-gradient-to-r from-amber-50 to-yellow-50 rounded-xl p-4 border border-amber-200 shadow-sm">
      <div className="flex items-center mb-3">
        <div className="p-2 bg-amber-500 rounded-lg mr-3">
          <Package className="w-4 h-4 text-white" />
        </div>
        <h3 className="font-semibold text-gray-800 text-lg">Descriere</h3>
      </div>
      <textarea
        value={formData.descriere || ""}
        onChange={(e) =>
          setFormData(prev => ({ ...prev, descriere: e.target.value }))
        }
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 resize-none"
        rows={3}
        placeholder="Detalii despre transport..."
      />
    </div>
  );
};

export default DescriptionSection;